import Footer from "../../components/Footer";
import Header from "../../components/Header";
import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";
import SubstationInfrastructure from "../../components/Service/Subservice/substationInfrastructure";
// Import the new substation component you just created


export default function Substation() {
    return (
        <>
            <Header/>
            {/* Update the title to reflect Substation Building services */}
            <SubServiceBanner title={"Substation Building & Infrastructure"}/>
            
            <SubstationInfrastructure/>
            
            <Footer/>
        </>
    )
}